/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
// import LayoutOperation from "../../../components/layout_operation";
import {
  // DownOutlined,
  MenuOutlined,
  // UploadOutlined,
  // PlusOutlined,
} from "@ant-design/icons";
import {  Radio, Table, Input, Modal, Checkbox } from "antd";
// import Map from "../../../ui/map/assign_job";
import Cookies from "js-cookie";
import { connect } from "react-redux";
// import moment from "moment";
import Api from "../../../services/ServiceApi";
import { changeLang } from "../../../actions/langAction";
// import FormItem from "antd/lib/form/FormItem";
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";

const DragHandle = sortableHandle(() => (
  <MenuOutlined style={{ cursor: "pointer", color: "#999" }} />
));
// const { Option } = Select;

const SortableItem = sortableElement((props) => <tr {...props} />);
const SortableContainer = sortableContainer((props) => <tbody {...props} />);

class AddCheckList extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      title: "ADD CHECK LIST",
      job_type: [],
      sub_type: [],
      jobcategory: "",
      form: [
        {
          no: "",
          description: "",
        },
      ],
      form_detail: [
        {
          job_checklist_name: "",
          check_flag: 0,
          remark_flag: 0,
          photo_flag: 0,
          job_checklist_type: 1,
        },
      ],
      Priority: 1,
      modalstatus: false,
      set_asset: [],
      status_cookie: 0,
      job_cat: [],
      data_translate: [],
      factupdate: false,
      columns: [
        {
          title: "No",
          dataIndex: "",
          // key: "",
          align: "center",
          render: (item) =>
            item.job_checklist_type === 0 ? (
              <h6
                style={{
                  color: "#2152c8",
                  fontSize: "18px",
                  fontWeight: "600",
                  padding: "1px",
                }}
              >
                {" "}
                {"Title"}{" "}
              </h6>
            ) : (
              <DragHandle />
            ),
          className: "drag-visible",
        },
        // job_checklist_id
        {
          title: "Description",
          dataIndex: "",
          // key: "job_checklist_name",
          className: "drag-visible",
          render: (item) =>
            item.job_checklist_type === 0 ? (
              <h6
                style={{
                  color: "#2152c8",
                  fontSize: "18px",
                  fontWeight: "400",
                  padding: "1px",
                }}
              >
                {" "}
                {item.job_checklist_name}{" "}
              </h6>
            ) : (
              item.job_checklist_name
            ),
        },
        // job_checklist_name
        {
          title: "Check Box",
          dataIndex: "",
          // key: "check_flag",
          align: "center",
          render: (item) =>
            item.job_checklist_type === 0 ? null : item.check_flag === null ||
              item.check_flag === 0 ? (
              <Checkbox checked={false} />
            ) : (
              <Checkbox checked={true} />
            ),
        },
        {
          title: "หมายเหตุ",
          // key: "remark_flag",
          dataIndex: "",
          align: "center",
          render: (item) =>
            item.job_checklist_type === 0 ? null : item.remark_flag === null ||
              item.remark_flag === 0 ? (
              <Checkbox checked={false} />
            ) : (
              <Checkbox checked={true} />
            ),
        },
        {
          title: "Photo",
          dataIndex: "",
          // key: "photo_flag",
          align: "center",
          render: (item) =>
            item.job_checklist_type === 0 ? null : item.photo_flag === null ||
              item.photo_flag === 0 ? (
              <Checkbox checked={false} />
            ) : (
              <Checkbox checked={true} />
            ),
        },
        {
          title: "Action",
          dataIndex: "",
          // key: "",
          align: "center",
          // sorter: () => null,
          render: (item) => (
            <>
              {item.job_checklist_type === 0 ? (
                ""
              ) : (
                <>
                  <a
                    className="font-thai-sb fs-18 text-underlinem ml-3"
                    style={{ color: "#6864FF" }}
                    onClick={() => this.setcolum_title()}
                  >
                    <img
                      style={{
                        float: "center",
                        marginLeft: "-15px",
                      }}
                      src={Api.absoluteUrl("/icon/add_colum.svg")}
                    />
                  </a>
                  <a
                    className="font-thai-sb fs-18 text-underline ml-3"
                    style={{ color: "#6864FF" }}
                    onClick={() => this.onDelete(item)}
                  >
                    <img
                      style={{
                        float: "center",
                        marginLeft: "-15px",
                      }}
                      src={Api.absoluteUrl("/icon/delete_colum.svg")}
                    />
                  </a>
                </>
              )}
            </>
          ),
        },
      ],
      columns_description: [
        {
          title: "No.",
          dataIndex: "no",
          key: "no",
        },
        {
          title: "Description",
          dataIndex: "description",
          key: "description",
        },
        {
          title: "Action",
          dataIndex: "",
          key: "",
        },
      ],
      dataSource: [],
      index_color: 0,
      update_des: false,
      display_des: [],
      data_set: {},
      visible_modal: false,
      title_name: "",
    };
  }
  async componentDidMount() {
    document.title = "MaxiOperation - " + this.state.title;
    const GetJobCategoty = await Api.post("get_job_category_V2", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_category_id: null,
      is_active: 1,
      date_active: 1,
    });
    const data_language = await Api.post("master_language_detail_get", {
      company_id: Cookies.get("companyid"),
      page_id: 1,
    });

    const sub_checkList = await Api.post("get_jobchecklist_master_all", {
      page_id: 1,
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
    });
    for (let i = 0; i < sub_checkList.data.data.length; i++) {
      sub_checkList.data.data[i]["index"] = i;
      sub_checkList.data.data[i]["key"] = i + 1;
    }
    this.setState({
      dataSource: sub_checkList.data.data,
      job_cat: GetJobCategoty.data.data.result_data,
      data_translate: JSON.parse(
        data_language.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
      ),
      factupdate: true,
    });
  }
  onSortEnd = ({ oldIndex, newIndex }) => {
    const { dataSource } = this.state;
    if (oldIndex !== newIndex) {
      const newData = arrayMove(
        [].concat(dataSource),
        oldIndex,
        newIndex
      ).filter((el) => !!el);
      this.setState({ dataSource: newData });
    }
  };
  DraggableBodyRow = ({ className, style, ...restProps }) => {
    const { dataSource } = this.state;
    const index = dataSource.findIndex(
      (x) => x.index === restProps["data-row-key"]
    );
    return <SortableItem index={index} {...restProps} />;
  };
  async btnjobDetail(n) {
    Api.post("get_job_type", {
      pk_id: null,
      fk_id: n,
      is_active: "1",
      effective: "1",
      sql_where: null,
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
    })
      .then((response) => {
        this.setState({
          selected_jobtype: null,
          selected_subtype: null,
          sub_type: [],
          jobcategory: n,
          job_type: response.data.data,
        });
        // setTimeout(() => {
        //   this.Setdata_jobtype(this.state.data_local.job_type_id);
        // }, 100);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  handleSubmit = async () => {
    console.log(this.state.form);
    console.log(this.state.data_set);
    console.log(this.state.dataSource);
  };
  setcolum_title = () => {
    this.setState({
      dataSource: [
        ...this.state.dataSource,
        {
          job_checklist_id: this.state.dataSource.length + 1,
          job_checklist_name: (
            <Input
              placeholder="Description"
              id={this.state.dataSource.length}
              onChange={(value) => this.handleDataTitle(value)}
            />
          ),
          checkbox: <Checkbox />,
          remark: <Checkbox />,
          photo: <Checkbox />,
        },
      ],
    });
    this.state.form.push({
      no: "",
      description: "",
    });
  };
  onDelete = async (key) => {
    // console.log(key.no);
    // console.log(this.state.dataSource);
    // const dataSource_title = [...this.state.dataSource];
    // console.log(this.state.dataSource);
    // const setdataSource = await this.state.dataSource.filter((item) => item.no !== key.no);
    // const setdata_des = dataSource_des.filter((item) => item.no !== key.no);

    // console.log(setdataSource);
    // for (let i = 0; i < setdataSource.length; i++) {
    //   setdataSource[i]["no"] = i + 1;
    // }
    // for (let i = 0; i < setdata_des.length; i++) {
    //   setdata_des[i]["no"] = i + 1;

    // console.log(setdataSource);
    const dataSource = [...this.state.dataSource];
    const setdataSource = await dataSource.filter((item) => item.no !== key.no);
    this.setState({
      dataSource: setdataSource,
    });
    // this.setState({ dataSource: setdataSource });
  };
  handleDataTitle = (data) => {
    this.state.form[data.target.id]["no"] = parseInt(data.target.id) + 1;
    this.state.form[data.target.id]["description"] = data.target.value;
  };
  handleData = (data, index, name) => {
    this.state.form_detail[index][name] = data;
  };
  Adddescription = () => {
    this.state.dataSource.push({
      job_checklist_name: this.state.title_name,
      job_checklist_type: 0,
      remark_flag: null,
      check_flag: null,
      photo_flag: null,
      index: this.state.dataSource.length,
      key: this.state.dataSource.length + 1,
    });
    for (let i = 0; i < this.state.form_detail.length; i++) {
      this.state.form_detail[i]["index"] = this.state.dataSource.length;
      this.state.form_detail[i]["key"] = this.state.dataSource.length + 1;
    }
    this.setState({
      dataSource: [...this.state.dataSource, ...this.state.form_detail],
    });
    this.setState({
      form_detail: [
        {
          job_checklist_name: "",
          check_flag: 0,
          remark_flag: 0,
          photo_flag: 0,
          job_checklist_type: 1,
        },
      ],
      title_name: "",
    });
  };
  Addsubdes = () => {
    this.state.form_detail.push({
      id: this.state.form_detail.length + 1,
      job_checklist_name: "",
      check_flag: 0,
      remark_flag: 0,
      photo_flag: 0,
    });

    // this.state.form_detail[index].push({
    //   no: position + 1,
    //   description: "",
    // });
    this.setState({
      form_detail: this.state.form_detail,
    });
  };
  async Setdata_jobtype(value) {
    const checkwf = this.state.job_type.find(
      (element) => parseInt(element.job_type_id) === parseInt(value)
    );
    if (checkwf.wf_id === null) {
      this.setState({
        checkbtn: false,
      });
    } else {
      Api.post("getButtonDetailWeb", {
        WF_ID: checkwf.wf_id,
        CompanyID: Cookies.get("companyid"),
        ProjectID: Cookies.get("project_id"),
        JobTypeID: value,
        Version: 1,
        MainProcessID: "0",
        SubProcessID: "-1",
        ActionID: 1,
        UserName: Cookies.get("username"),
        operator_id: Cookies.get("operator_id"),
      })
        .then((response) => {
          if (response.data.return_nextWorkFlow.length === 0) {
            this.setState({
              checkbtn: false,
              status_button_workflow: "กรุณาตรวจสอบการเลือก Job Type !!",
            });
          } else {
            this.setState({
              checkbtn: true,
              WorkFlow: response.data.return_nextWorkFlow,
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
    Api.post("get_job_sub_type", {
      job_sub_type_id: null,
      job_category_id: this.state.jobcategory,
      job_type_id: value,
      is_active: 1,
      effective: 1,
      sql_where: " and company_id=" + Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      // sql_where: null,
    })
      .then((response) => {
        this.setState({
          selected_jobtype: value || null,
          sub_type: response.data.data.job_sub_type_dto_list,
        });
      })
      .catch((e) => {
        console.log(e);
      });
    // Api.get(
    //   "get_service_type_ma",
    //   "?company_id=1&job_category_id=" +
    //     this.state.jobcategory +
    //     "&job_type_id=" +
    //     value +
    //     "&service_type_level_id=01000000"
    // )
    //   .then((response) => {
    //     this.setState({
    //       ObjectPart: response.data.data.result_service_type_ma,
    //     });
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });

    Api.post("get_service_type_ma_list_each_level", {
      company_id: Cookies.get("companyid"),
      job_category_id: this.state.jobcategory,
      job_type_id: value,
      service_lv1: null,
      service_lv2: null,
      service_lv3: null,
      service_lv4: null,
      operator_id: Cookies.get("operator_id"),
    })
      .then((response) => {
        // this.state.form["service_type_level_id"] = value;
        this.setState({
          ObjectPart: response.data.data.result,
        });
      })
      .catch((e) => {
        console.log(e);
      });

    this.setState({
      customs: {
        select_object_path: null,
      },
      sel_type: null,
      sel_new_type: null,
      sel_sub_cat: null,
      ObjectPart: [],
      serviceType: [],
      newType: [],
      subCategory: [],
      sla_level: [],
      std_hour: "",
      std_day: "",
      std_minute: "",
      sla_id: "",
      sel_sla: null,
    });
  }
  DraggableContainer = (props) => (
    <SortableContainer
      useDragHandle
      helperClass="row-dragging"
      onSortEnd={this.onSortEnd}
      {...props}
    />
  );
  renderModal() {
    return (
      <Modal
        title={
          <span className="font-mont-b fs-16 c-blue">ADD Title / Detaill</span>
        }
        centered
        visible={this.state.visible_modal}
        footer={null}
        closable={true}
        onCancel={() => this.setState({ visible_modal: false })}
        className="custom-modal"
      >
        <div className="d-flex align-items-center row">
          {/* <div className="mr-4">
            <span className="font-thai-r fs-18">Status</span>
        </div>
        <Radio.Group onChange={this.onChange} >
            <Radio value={1}><span className="font-thai-r fs-18">Active</span></Radio>
            <Radio value={2}><span className="font-thai-r fs-18">Inactive</span></Radio>
        </Radio.Group> */}
          {/* <div className="row"> */}
          <div className="col-6">
            <label className="labeaddjob">{"Title  Name"}</label> <br />
            <Input
              placeholder="Title  Name"
              onChange={(e) => this.setState({ title_name: e.target.value })}
            />
          </div>
          <div className="col-6">
            {/* <label className="labeaddjob">{"Status"}</label> <br />
            <Radio.Group onChange={this.onChange}>
              <Radio value={1}>
                <span className="font-thai-r fs-18">Active</span>
              </Radio>
              <Radio value={2}>
                <span className="font-thai-r fs-18">Inactive</span>
              </Radio>
            </Radio.Group> */}
          </div>
          <div
            className="col-12"
            style={{
              paddingLeft: "0px",
              paddingRight: "0px",
              textAlign: "right",
            }}
          >
            <button
              type="button"
              className="btn btn-success"
              style={{
                backgroundColor: "#28a745",
                borderColor: "#28a745",
                color: "#FFFFFF",
              }}
              onClick={() => this.Addsubdes()}
            >
              Add Colums
            </button>
          </div>
          <div className="col-12 mt-3">
            <div className="row">
              <div className="col-6">
                <label className="labeaddjob">{"Description"}</label>
              </div>
              <div className="col-2" style={{ textAlign: "center" }}>
                <label className="labeaddjob">{"Check Box"}</label>
              </div>
              <div className="col-2" style={{ textAlign: "center" }}>
                <label className="labeaddjob">{"หมายเหตุ"}</label>
              </div>
              <div className="col-2" style={{ textAlign: "center" }}>
                <label className="labeaddjob">{"Photo"}</label>
              </div>
            </div>
          </div>
          <div className="col-12 mt-1">
            {this.state.form_detail.map((item, index) => {
              return (
                <div className="row mt-2">
                  {/* <div className="col-3"> */}
                  {/* <label className="labeaddjob">{index}</label> */}
                  {/* </div> */}
                  <div className="col-5">
                    <Input
                      style={{ maxWidth: "100%" }}
                      placeholder="Description"
                      // id={i} this.handleData(index, i, value)
                      onChange={(e) =>
                        this.handleData(
                          e.target.value,
                          index,
                          "job_checklist_name"
                        )
                      }
                    />
                  </div>
                  <div className="col-2" style={{ textAlign: "center" }}>
                    <Checkbox
                      name="check_flag"
                      onChange={(e) =>
                        this.handleData(
                          e.target.checked ? 1 : 0,
                          index,
                          e.target.name
                        )
                      }
                    />
                  </div>
                  <div className="col-2" style={{ textAlign: "center" }}>
                    <Checkbox
                      name="remark_flag"
                      onChange={(e) =>
                        this.handleData(
                          e.target.checked ? 1 : 0,
                          index,
                          e.target.name
                        )
                      }
                    />
                  </div>
                  <div className="col-2" style={{ textAlign: "center" }}>
                    <Checkbox
                      name="photo_flag"
                      onChange={(e) =>
                        this.handleData(
                          e.target.checked ? 1 : 0,
                          index,
                          e.target.name
                        )
                      }
                    />
                  </div>
                  <div className="col-2" style={{ textAlign: "center" }}></div>
                </div>
              );
            })}
          </div>
          <div
            className="col-12"
            style={{
              paddingLeft: "0px",
              paddingRight: "0px",
              textAlign: "center",
            }}
          >
            <button
              type="button"
              className="btn btn-success mt-3"
              style={{
                backgroundColor: "#17a2b8",
                borderColor: "#17a2b8",
                color: "#FFFFFF",
              }}
              onClick={() => this.Adddescription()}
            >
              Add Tital / Detail
            </button>
          </div>
        </div>
      </Modal>
    );
  }
  render() {
    // const { loading, title } = this.state;
    // const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];
    const job_cat_btn = this.state.job_cat.map((job_cat, index) => {
      let thismr = "";
      if ((index + 1) % 5 == 0 && index != 0) {
        thismr = "mr-2 ";
      }
      return (
        <div
          key={index + 5478}
          className={"col-2 " + thismr + "p0"}
          style={{ marginBottom: "10px" }}
        >
          <button
            type="button"
            className={
              this.state.jobcategory === job_cat.job_category_id
                ? "btndetailshow"
                : "btndetailhide"
            }
            // disabled={this.state.fack_check === 1 ? true : false}
            onClick={this.btnjobDetail.bind(this, job_cat.job_category_id)}
          >
            <img
              style={{
                float: "right",
                marginRight: "10px",
              }}
              src={Api.absoluteUrl(
                this.state.jobcategory === job_cat.job_category_id
                  ? "/icon/job_show.svg"
                  : "/icon/job_dis.svg"
              )}
            />
            <br className="mt-2" />
            <img
              style={{
                float: "center",
                marginLeft: "-15px",
              }}
              src={Api.absoluteUrl("/icon/" + job_cat.icon_name)}
            />
            <span
              style={{
                marginLeft: "-20px",
                fontSize: "12px",
                color: "#0500A3",
              }}
            >
              <br className="mt-2" />
              {job_cat.job_category_name}
            </span>
          </button>
        </div>
      );
    });
    return (
      <>
        {this.state.factupdate ? (
          <>
            {this.renderModal()}
            <div
              className="container mb-2"
              style={{ maxWidth: "95%", marginTop: "0%" }}
            >
              <div className="row">
                <div
                  className="col-12 mt-2 "
                  style={{ paddingLeft: "0px", paddingRight: "0px" }}
                >
                  <span style={{ color: "#0500A3", fontSize: "16px" }}>
                    <img
                      src={Api.absoluteUrl("/icon/pust.svg")}
                      width="14"
                      className="mr-2"
                    />
                    <b> {this.state.title}</b>
                  </span>
                  <div className="card mt-2" style={{ width: "95%" }}>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-3"></div>
                        <div className="col-3">
                          <label className="labeaddjob">{"Name"}</label> <br />
                          <Input placeholder="Name" />
                        </div>
                        <div className="col-3">
                          <label className="labeaddjob">{"Status"}</label>
                          <br />
                          <Radio.Group
                            onChange={this.onChange}
                            value={this.state.value}
                          >
                            <Radio value={1}>Active</Radio>
                            <Radio value={2}>Inactive</Radio>
                          </Radio.Group>
                        </div>
                        <div className="col-3"></div>
                      </div>
                    </div>
                  </div>
                  <div className="card mt-2" style={{ width: "95%" }}>
                    <div className="card-body">
                      <div className="mt-2 divshow">
                        <div className="row">
                          {/* <div className="col-2"> </div> */}
                          <div className="col-12">
                            <img
                              style={{
                                float: "left",
                                marginTop: "7px",
                                marginRight: "10px",
                              }}
                              src={Api.absoluteUrl("/icon/setting.svg")}
                            />
                            <span className="jobdetail">
                              {" "}
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["job_detail"]
                              }
                            </span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-2"> </div>
                          <div className="col-10">
                            <div className="row">
                              <div className="col-12">
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                      Cookies.get("locale")
                                    ]["job_category"]
                                  }{" "}
                                  <b style={{ color: "#DF4547" }}>*</b>
                                </label>
                                <br />
                                <div className="row">{job_cat_btn}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-5">
                          <div className="col-2"> </div>
                          <div className="col-10">
                            <div className="row">
                              <div className="col-6">
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                      Cookies.get("locale")
                                    ]["job_type"]
                                  }{" "}
                                  <b style={{ color: "#DF4547" }}> * </b>{" "}
                                </label>
                                <br />
                                <select
                                  style={{ height: "30px", width: "80%" }}
                                  onChange={(e) =>
                                    this.Setdata_jobtype(e.target.value)
                                  }
                                  defaultValue={
                                    this.state.selected_jobtype || ""
                                  }
                                  value={this.state.selected_jobtype}
                                >
                                  <option value="" disabled>
                                    Please select
                                  </option>
                                  {this.state.job_type.map((item, index) => (
                                    <option
                                      value={item.job_type_id}
                                      defaultValue={this.state.selected_jobtype}
                                    >
                                      {item.job_type_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-6">
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                      Cookies.get("locale")
                                    ]["job_sub_type"]
                                  }{" "}
                                </label>
                                <br />
                                <select
                                  style={{ height: "30px", width: "80%" }}
                                  // className="dropdrowtype"
                                  onChange={(e) =>
                                    this.setState({
                                      selected_subtype: e.target.value || null,
                                    })
                                  }
                                  defaultValue={this.state.selected_subtype}
                                  value={this.state.selected_subtype}
                                >
                                  <option value="" disabled>
                                    Please select
                                  </option>
                                  {this.state.sub_type.map((item, index) => (
                                    <option
                                      value={item.job_sub_type_id}
                                      defaultValue={this.state.selected_subtype}
                                    >
                                      {item.job_type_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card mt-2 " style={{ width: "95%" }}>
                    <div className="card-body">
                      <div className="mt-2 divshow">
                        <div className="row">
                          {/* <div className="col-2"> </div> */}
                          <div className="col-6">
                            <img
                              style={{
                                float: "left",
                                marginTop: "7px",
                                marginRight: "10px",
                              }}
                              src={Api.absoluteUrl("/icon/setting.svg")}
                            />
                            <span className="jobdetail">{"Detail"}</span>
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className="col-12"
                            style={{
                              paddingLeft: "0px",
                              paddingRight: "0px",
                              textAlign: "right",
                            }}
                          >
                            <button
                              type="button"
                              className="btnSubmit mr-3"
                              onClick={() =>
                                this.setState({ visible_modal: true })
                              }
                            >
                              <span style={{ fontSize: "16px" }}>
                                Add Title
                              </span>
                            </button>
                          </div>
                          <div className="col-12 mt-4">
                            <Table
                              pagination={false}
                              dataSource={this.state.dataSource}
                              columns={this.state.columns}
                              rowKey="index"
                              components={{
                                body: {
                                  wrapper: this.DraggableContainer,
                                  row: this.DraggableBodyRow,
                                },
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-12 mt-4"
                  style={{
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    textAlign: "center",
                  }}
                >
                  <button
                    type="button"
                    className="btnCancel "
                    // onClick={this.handleSubmit}
                  >
                    <span style={{ fontSize: "16px" }}>Cancel</span>
                  </button>
                  <button
                    type="button"
                    className="btnSubmit ml-2"
                    onClick={this.handleSubmit}
                  >
                    <span style={{ fontSize: "16px" }}>Submit</span>
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : null}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(AddCheckList);
